import { render, staticRenderFns } from "./the-add-batch.vue?vue&type=template&id=3f99a6fe&scoped=true&"
import script from "./the-add-batch.vue?vue&type=script&lang=js&"
export * from "./the-add-batch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f99a6fe",
  null
  
)

export default component.exports